export default __webpack_public_path__ + "static/media/free-twitter-logo-icon-2429-thumb.cbfb1f67.png";